const emptyMessage = {
  kind: 1, // 消息内容类型，1文字，2文章
  textContent: '', // 消息文字内容
  article: {
    art_id: '', // 文章id
    title: '', // 文章标题
    content_source_url: '', // 文章url
    cover_url: '', // 文章封面url
    digest: '', // 文章摘要
  },
};

module.exports = emptyMessage;
